import script from "./BaseSvgWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSvgWrapper.vue?vue&type=script&setup=true&lang=js"

import "./BaseSvgWrapper.vue?vue&type=style&index=0&id=0674ebb3&scoped=true&lang=scss"

import exportComponent from "D:\\online\\paramedicsuz_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0674ebb3"]])

export default __exports__